import { createFeatureSelector, createSelector } from "@ngrx/store";
import * as fromFocus from "./focus.reducer";

export const selectFocusState = createFeatureSelector<fromFocus.State>(
  fromFocus.focusFeatureKey,
);

export const selectFocus = createSelector(selectFocusState, (s) => s?.focus);
